import t, { useContext as e } from "react";
const n = t.createContext({
  clientId: "",
  apiRoot: "",
  prevStage: null,
  setAppHandlers: () => {
  }
});
function c() {
  return e(n);
}
export {
  n as AppContext,
  c as useAppContext
};
